import { useConfig } from './use-config';
import type { ConfigEntry } from '../types';

type Entry = ConfigEntry | null | undefined;
type Result = { base: Entry[]; extra: Entry[]; loading: boolean };

function useBaseEntries(): Entry[] {
  return [
    useConfig('payment_cycle_days').data,
    useConfig('payment_threshold').data,
    useConfig('minimum_leads_count').data,
    useConfig('minimum_leads_period').data,
    useConfig('bonus_period').data,
    useConfig('bonus_amounts').data,
    useConfig('ranking_period').data,
    useConfig('weekly_goal').data,
    useConfig('total_goal').data,
    useConfig('group_bonus_amount').data,
  ];
}

function useRaceEntries(): Entry[] {
  return [
    useConfig('daily_first_to_x_enabled').data,
    useConfig('daily_first_to_x_threshold').data,
    useConfig('daily_first_to_x_amount_usd').data,
    useConfig('weekly_first_to_x_enabled').data,
    useConfig('weekly_first_to_x_threshold').data,
    useConfig('weekly_first_to_x_amount_usd').data,
    useConfig('monthly_first_to_x_enabled').data,
    useConfig('monthly_first_to_x_threshold').data,
    useConfig('monthly_first_to_x_amount_usd').data,
  ];
}

function useExtraEntries(): Entry[] {
  return [
    useConfig('payment_day_of_week').data,
    useConfig('daily_minimum_leads').data,
    useConfig('top_tier_threshold').data,
    useConfig('top_tier_days_required').data,
    useConfig('pre_ban_failed_days_threshold').data,
    useConfig('pre_ban_grace_days').data,
    useConfig('minimum_payout_banned').data,
    ...useRaceEntries(),
  ];
}

export function useSettingsData(): Result {
  const base = useBaseEntries();
  const extra = useExtraEntries();
  return { base, extra, loading: !base[0] && !base[1] };
}
